import type { PagePreview } from '../ui/formats/DocView'

export async function fetchHtmlPagePreview(
  mint: () => Promise<{ url: string }>,
): Promise<PagePreview> {
  const ticket = await mint()
  const url = new URL(ticket.url, window.location.href)
  url.searchParams.set('as', 'page')
  const response = await fetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  if (!response.ok) throw new Error('The page preview could not be prepared.')
  return response.json()
}
